module.exports = __webpack_public_path__ + "img/ennetix-flows-tab-diagram.fa021ac1.png";